export default __webpack_public_path__ + "b1fac335d3804d9dadf795e093048b40.woff2";